<template>
  <v-row>
    <v-col cols="12" v-for="(item,index) in cbus" :key="index">
      <v-divider></v-divider>
      <v-row>

        <v-col cols="12" sm="4">
          <field-view  :value="item.origen"
                       :label="$t('cobrox.persona.labels.origen')"
                       icon="source"
          />
        </v-col>

        <v-col cols="12" sm="4">
          <field-view  :value="item.descripcion"
                       :label="$t('cobrox.persona.labels.descripcion')"
                       icon="view_list"
          />
        </v-col>


        <v-col cols="12" sm="4">
          <field-view  :value="item.cbu"
                       :label="$t('cobrox.persona.labels.cbu')"
                       icon="mail"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import FieldView from "@/modules/cobrox/components/FieldView/FieldView";
export default {
  name: "PersonaCbusView",
  components: {FieldView},
  props: {
    cbus: Array
  }
}
</script>

<style scoped>

</style>
